import Vue from 'vue';

Vue.directive('debug', function (el, binding) {
  if (typeof binding.value !== 'boolean') {
  } else {
  }
});



// WEBPACK FOOTER //
// ./src/utils/directives/_debug.js